import { apiDaInscricao } from './axios';

export const carregarRegimesDeCasamento = async () => {
  const { data: regimesDeCasamento } = await apiDaInscricao().get('/regimeDeCasamento/ObterTodos');
  return regimesDeCasamento;
};